// Meal type constants

export const MEAL_TYPES = ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Add On'];

export const DELIVERY_DAYS = {
    MONDAY: 1,
    THURSDAY: 4,
    SUNDAY: 0
};

export const LOCK_HOURS = {
    MONDAY_DELIVERY: 12, // 12 PM EST on Saturday
    THURSDAY_DELIVERY: 12, // 12 PM EST on Tuesday
    SUNDAY_DELIVERY: 20, // 8 PM EST on Friday
    OTHER_DELIVERY: 12 // 12 PM EST on Thursday
};

export const CARD_CONFIG = {
    WIDTH: 280,
    GAP: 15
};

export const MEAL_PRICES = {
    'Breakfast': 12.99,
    'Lunch': 19.99,
    'Dinner': 23.99,
    'Snack': 5.99
};

export const SUBSCRIPTION_DISCOUNT = 0.9;